import {Injectable} from '@angular/core';
import {LorenBaseEndpointsService} from '../../../../shared/services/loren-base-endpoints-service/loren-base-endpoints.service';

@Injectable({
    providedIn: 'root'
})
export class LorenUserSettingsEndpointsService extends LorenBaseEndpointsService {

    constructor() {
        super();
    }

    userNotificationsSubscriptions(userId: number) {
        return `${this.getApiServerUrl()}/users/${userId}/notifications/subscriptions`;
    }
}
